import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IReportRequest, IReturnSummaryByDealer } from '../models/models'

export class GetOrderReportByDealerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/returnReport/ReturnReportsByDealer',
      requesterInfo,
    })
  }

  public async getReport(req: IReportRequest): Promise<IReturnSummaryByDealer[]> {
    return await this.postAsync<IReturnSummaryByDealer[]>(req)
  }
}
